module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/chat-6-043c01ca3bd96a2972bb5a323f993a5e.svg";